import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import HealthPage from './HealthPage';
import CriticalPathPage from './CriticalPathPage';
import MilestonesPage from './MilestonesPage';
import QualityPage from './QualityPage';
import OverviewCockpitPage from './OverviewCockpit';
import ChartsPage from './Charts';
import CatalogPage from './CatalogPage';
import AnalyticsSettingsPage from './AnalyticsSettingsPage';

const Analytics: React.FC = () => {
  return (
    <MainLayout title="Analytics">
      <div className="flex flex-col flex-1 min-h-0 p-6 pt-6">
        <div className="flex-1 overflow-auto mt-4 min-h-0">
          <Routes>
            {/* Default: /app/analytics -> Overview (System Cockpit) */}
            <Route path="/" element={<Navigate to="/app/analytics/overview" replace />} />
            {/* Overview: System Cockpit (replaces old chart grid) */}
            <Route path="overview" element={<OverviewCockpitPage />} />
            {/* Chart focus view (preserved for drill-through into specific charts) */}
            <Route path="charts" element={<ChartsPage />} />
            {/* Library / Catalog */}
            <Route path="catalog" element={<CatalogPage />} />
            {/* Analytics settings */}
            <Route path="settings" element={<AnalyticsSettingsPage />} />
            {/* Sub-pages */}
            <Route path="health" element={<HealthPage />} />
            <Route path="critical-path" element={<CriticalPathPage />} />
            <Route path="milestones" element={<MilestonesPage />} />
            <Route path="quality" element={<QualityPage />} />
            {/* Catch-all -> Overview */}
            <Route path="*" element={<Navigate to="/app/analytics/overview" replace />} />
          </Routes>
        </div>
      </div>
    </MainLayout>
  );
};

export default Analytics;
